import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/expense-actions';
import { ExpenseActions } from '../constants';
import { IExpense } from 'src/types/expense';

export interface ExpenseState {
    inProgress: boolean;
    authCode: string;
    error: string;
    data: Paginated<IExpense>;
    current: IExpense | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    data: {
        list: [],
        inProgress: false,
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
    current: null,
    currentFiles: null,
};

export function expenses(state: ExpenseState = initialState, action: Actions | any): ExpenseState {
    switch (action.type) {
        case requestType(ExpenseActions.PERSIST_EXPENSE):
            return { ...state, error: '', inProgress: true };
        case successType(ExpenseActions.PERSIST_EXPENSE):
            return { ...state, inProgress: false };
        case failureType(ExpenseActions.PERSIST_EXPENSE):
            return { ...state, error: action.error, inProgress: false };
        case requestType(ExpenseActions.FETCH_EXPENSES):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    page: 1,
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(ExpenseActions.FETCH_EXPENSES):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(ExpenseActions.FETCH_EXPENSES):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(ExpenseActions.FETCH_EXPENSE):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(ExpenseActions.FETCH_EXPENSE):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(ExpenseActions.FETCH_EXPENSE):
            return { ...state, inProgress: false, error: action.error };
        case requestType(ExpenseActions.DELETE_EXPENSE):
            return { ...state, error: '', inProgress: true };
        case successType(ExpenseActions.DELETE_EXPENSE):
            let idDel = action.payload.id;
            if (!idDel) {
                idDel = action.sagaPayload.id;
            }
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: IExpense) => {
                        return user.id !== idDel;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(ExpenseActions.DELETE_EXPENSE):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        default:
            return state;
    }
}
